import React from "react";
import {
  Grid,
  TextField,
  Switch,
  FormControlLabel,
  FormLabel,
  RadioGroup,
  Radio,
  FormControl,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Checkbox,
  Collapse,
  Box,
  useTheme,
  makeStyles,
} from "@material-ui/core";
import LocationCityRoundedIcon from "@material-ui/icons/LocationCityRounded";
import { CurrencySign } from "../../config/jobsConfigData";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiFormControl-fullWidth": {
      minWidth: 150,
      width: "100%",
    },
    "& .MuiSvgIcon-root": {
      color: theme.palette.grey[500],
    },
  },
}));

const JobDetailsViewStep2 = ({
  authorName,
  coordinatorDisplayName,
  professions,
  jobExtent,
  jobArea,
  jobCity,
  salaryMin,
  salaryMax,
  discreteSalary,
  isOpenSalaryQuestion,
  openSalaryValueBy,
}) => {
  const theme = useTheme();
  const classes = useStyles();
  return (
    <Grid container spacing={2} className={classes.root}>
      <Grid item xs={6}>
        <TextField
          required
          label="Recruiter Owner"
          margin="none"
          fullWidth
          value={authorName}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          required
          label="Recruiter display name"
          id="displayName"
          margin="none"
          fullWidth
          value={coordinatorDisplayName}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          required
          label="Relevant Professions"
          id="professions"
          margin="normal"
          fullWidth
          value={professions}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          required
          label="Job Type"
          id="jobExtent"
          margin="normal"
          fullWidth
          value={jobExtent}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          required
          label="Job Area"
          id="jobExtent"
          margin="normal"
          fullWidth
          value={jobArea}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          label="City"
          id="jobCity"
          margin="normal"
          fullWidth
          value={jobCity ? jobCity : ""}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LocationCityRoundedIcon />
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item xs={3}>
        <FormControl variant="outlined" fullWidth>
          <InputLabel htmlFor="minimumAmount">Salary starts from</InputLabel>
          <OutlinedInput
            id="minimumAmount"
            value={salaryMin}
            type="number"
            inputProps={{ min: 0, step: 500 }}
            startAdornment={
              <InputAdornment position="start">
                {CurrencySign.symbol}
              </InputAdornment>
            }
            labelWidth={80}
          />
        </FormControl>
      </Grid>
      <Grid item xs={3}>
        <FormControl variant="outlined" fullWidth>
          <InputLabel htmlFor="maximumAmount">Max Salary</InputLabel>
          <OutlinedInput
            id="maximumAmount"
            value={salaryMax}
            type="number"
            inputProps={{ min: 0, step: 500 }}
            startAdornment={
              <InputAdornment position="start">
                {CurrencySign.symbol}
              </InputAdornment>
            }
            labelWidth={90}
          />
        </FormControl>
      </Grid>
      <Grid item xs={6} style={{ display: "flex", alignItems: "center" }}>
        <FormControlLabel
          label="Confidential Salary"
          control={
            <Switch
              checked={discreteSalary}
              color="primary"
              name="DiscreteJob"
            />
          }
        />
      </Grid>
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              checked={isOpenSalaryQuestion}
              color="primary"
              name="openSalaryQuestion"
            />
          }
          label="Show salary open question"
        />
      </Grid>
      <Grid item xs={12} style={{ display: "flex", alignItems: "center" }}>
        <Box display="flex" alignItems="center">
          <Collapse in={isOpenSalaryQuestion}>
            <FormLabel
              component="legend"
              style={{ marginLeft: theme.spacing(2) }}
            >
              Calculate wages value by:
            </FormLabel>
            <RadioGroup
              aria-label="openSalaryBy"
              name="openSalaryBy"
              value={openSalaryValueBy}
              style={{ flexDirection: "row" }}
            >
              <FormControlLabel
                value="month"
                control={<Radio color="primary" />}
                label="Monthly wages"
              />
              <FormControlLabel
                value="hour"
                control={<Radio color="primary" />}
                label="Hourly wages"
              />
            </RadioGroup>
          </Collapse>
        </Box>
      </Grid>
    </Grid>
  );
};
export default JobDetailsViewStep2;
